export default function AdminNav() {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark"
      style={{ backgroundColor: "#2C2C2C", borderBottom: "3px solid #C41230" }}
    >
      <div className="container">
        <a className="navbar-brand fw-bold" href="/admin">
          Admin Panel
        </a>

        <div className="collapse navbar-collapse">
          <ul className="navbar-nav ms-auto align-items-center">
            <li className="nav-item ms-3">
              <a className="btn btn-outline-light btn-sm" href="/">
                View Site
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
